/* InteriorExotics landing: deferred background video, card tilt, parallax, count-up, copy code. */
(() => {
  if (window.__ielBooted) return;
  window.__ielBooted = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  const wide = window.matchMedia('(min-width: 750px)').matches;

  const boot = () => {
    // Background videos only on larger screens with motion allowed; phones keep the light poster image.
    document.querySelectorAll('[data-iel-video]').forEach((video) => {
      if (reduceMotion || saveData || !wide) return;
      const start = () => {
        video.src = video.dataset.ielVideo;
        video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        video.play().catch(() => {});
      };
      new IntersectionObserver((entries, io) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        start();
      }).observe(video.parentElement);
    });

    // Subtle 3D tilt on product cards (pointer devices only)
    if (!reduceMotion && window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('[data-iel-tilt]').forEach((card) => {
        const media = card.querySelector('.iel-product__media');
        card.addEventListener('pointermove', (e) => {
          const r = media.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5;
          const y = (e.clientY - r.top) / r.height - 0.5;
          media.style.setProperty('--ry', `${x * 8}deg`);
          media.style.setProperty('--rx', `${y * -8}deg`);
        });
        card.addEventListener('pointerleave', () => {
          media.style.setProperty('--ry', '0deg');
          media.style.setProperty('--rx', '0deg');
        });
      });
    }

    // Parallax on the craft image
    const parallax = document.querySelectorAll('[data-iel-parallax]');
    if (parallax.length && !reduceMotion) {
      let ticking = false;
      const update = () => {
        parallax.forEach((img) => {
          const r = img.parentElement.getBoundingClientRect();
          const progress = Math.max(-1, Math.min(1, (r.top + r.height / 2 - innerHeight / 2) / innerHeight));
          img.style.setProperty('--iel-py', `${progress * -6}%`);
        });
        ticking = false;
      };
      addEventListener('scroll', () => {
        if (!ticking) requestAnimationFrame(update);
        ticking = true;
      }, { passive: true });
      update();
    }

    // Count-up for the stats (real values are already in the markup)
    if (!reduceMotion) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          const el = entry.target;
          const end = parseFloat(el.dataset.ielCount);
          const decimals = parseInt(el.dataset.decimals || '0', 10);
          const t0 = performance.now();
          const tick = (now) => {
            const p = Math.min(1, (now - t0) / 1400);
            const eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (end * eased).toFixed(decimals);
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.6 });
      document.querySelectorAll('[data-iel-count]').forEach((el) => io.observe(el));
    }

    // Tabbed new arrivals: sliding ink, arrow-key navigation, staggered card entrance
    document.querySelectorAll('[data-iel-tabs]').forEach((root) => {
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const ink = root.querySelector('.iel-tabs__ink');
      if (!tabs.length) return;
      const moveInk = (tab) => {
        if (!ink) return;
        ink.style.setProperty('--ink-x', `${tab.offsetLeft}px`);
        ink.style.setProperty('--ink-w', `${tab.offsetWidth}px`);
      };
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on && !reduceMotion) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
        moveInk(tab);
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
          if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
          if (step) { e.preventDefault(); select(tabs[(i + step + tabs.length) % tabs.length], true); }
        });
      });
      const current = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
      requestAnimationFrame(() => moveInk(current));
      addEventListener('resize', () => moveInk(tabs.find((t) => t.getAttribute('aria-selected') === 'true')), { passive: true });
    });

    // Copy discount code
    document.querySelectorAll('[data-iel-copy]').forEach((btn) => {
      const label = btn.querySelector('[data-iel-copy-label]');
      btn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(btn.dataset.ielCopy);
          label.textContent = 'Copied!';
        } catch (e) {
          label.textContent = btn.dataset.ielCopy;
        }
        setTimeout(() => (label.textContent = 'Tap to copy'), 2200);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
